/**
 * @file Consumer account related mutations.
 */

import gql from 'graphql-tag';

import { ConsumerAccountAddressFields } from '../fragments/account';

export const accountAddressCreate = gql`
  mutation accountAddressCreate($input: AccountAddressCreateInput!) {
    accountAddressCreate(input: $input) {
      account_address {
        ...ConsumerAccountAddressFields
      }
    }
  }
  ${ConsumerAccountAddressFields}
`;

export const accountAddressUpdate = gql`
  mutation accountAddressUpdate($input: AccountAddressUpdateInput!) {
    accountAddressUpdate(input: $input) {
      account_address {
        ...ConsumerAccountAddressFields
      }
    }
  }
  ${ConsumerAccountAddressFields}
`;
